import React from "react";
import { Spin } from "antd";

const LoadingState = ({ size, height }) => {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Spin size={size || "default"} />
    </div>
  );
};

export default LoadingState;
